import React, { Component } from 'react';
import TextField from 'material-ui/TextField';
import AmCharts from '@amcharts/amcharts3-react';
import HorizontalTimeline from 'react-horizontal-timeline';
import RaisedButton from 'material-ui/RaisedButton';
import { withRouter } from 'react-router-dom';
import Loading from './components/Loading';
import API from './api/ApiTool';

var targetSVG = "M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M9,15.93 c-3.83,0-6.93-3.1-6.93-6.93S5.17,2.07,9,2.07s6.93,3.1,6.93,6.93S12.83,15.93,9,15.93 M12.5,9c0,1.933-1.567,3.5-3.5,3.5S5.5,10.933,5.5,9S7.067,5.5,9,5.5 S12.5,7.067,12.5,9z";
var minBulletSize = 5;
var maxBulletSize = 12;

var defaultZoom = 1.2;
var preppedHtml

const VALUES = [];

let date = new Date();
const day = date.getDate();
const month = date.getMonth() + 1;
const year = date.getFullYear();
VALUES.push(month + "-" + day + "-" + year);

for (let i=0; i !== 60; i++) {
  date.setDate(date.getDate() - 1);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  VALUES.push(month + "-" + day + "-" + year);
}

var streams="";
VALUES.reverse();

let USAStatesMapToCode = {
  'Alabama':	'US-AL',
  'Alaska':	'US-AK',
  'Arizona':	'US-AZ',
  'Arkansas':	'US-AR',
  'California':	'US-CA',
  'Colorado':	'US-CO',
  'Connecticut':	'US-CT',
  'Delaware': 'US-DE',
  'District of Columbia':	'US-DC',
  'Florida': 'US-FL',
  'Georgia': 'US-GA',
  'Hawaii':	'US-HI',
  'Idaho': 'US-ID',
  'Illinois':	'US-IL',
  'Indiana': 'US-IN',
  'Iowa':	'US-IA',
  'Kansas':	'US-KS',
  'Kentucky': 'US-KY',
  'Louisiana': 'US-LA',
  'Maine': 'US-ME',
  'Maryland':	'US-MD',
  'Massachusetts': 'US-MA',
  'Michigan':	'US-MI',
  'Minnesota': 'US-MN',
  'Mississippi': 'US-MS',
  'Missouri':	'US-MO',
  'Montana': 'US-MT',
  'Nebraska':	'US-NE',
  'Nevada': 'US-NV',
  'New Hampshire':	'US-NH',
  'New Jersey':	'US-NJ',
  'New Mexico':	'US-NM',
  'New York':	'US-NY',
  'North Carolina': 'US-NC',
  'North Dakota':	'US-ND',
  'Ohio':	'US-OH',
  'Oklahoma':	'US-OK',
  'Oregon':	'US-OR',
  'Pennsylvania':	'US-PA',
  'Rhode Island':	'US-RI',
  'South Carolina':	'US-SC',
  'South Dakota':	'US-SD',
  'Tennessee':	'US-TN',
  'Texas': 'US-TX',
  'Utah':	'US-UT',
  'Vermont':	'US-VT',
  'Virginia':	'US-VA',
  'Washington':	'US-WA',
  'West Virginia': 'US-WV',
  'Wisconsin': 'US-WI',
  'Wyoming': 'US-WY'
}

class PullConferenceStreams extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      loading: true,
      data: {},
      period: 0,
      previousPeriod: 0,
      pause: false,
      historical: false,
      updating: false,
      zoomLevel: defaultZoom,
      zoomLongitude: "",
      zoomLatitude: "",
      usaMap: false
    };
  }
   

  fetchData() {
    const conferenceId = this.props.id || this.props.match.params.id;

    
    if (conferenceId) {
      API.POST(`/bridges/pull-streams-conference/`, {'id':conferenceId})      
      .then(response => response.json())
      .then(function (json) {
        document.getElementById("linkers").value=json.data.calls[0];
        console.log("set call to "+json.data.calls[0]);
        preppedHtml="<table><tr><td>Caller SID</td></tr>"
        Object.keys(json.data.calls).forEach(function(key) {
          preppedHtml += "<tr><td>" + json.data.calls[key] + "</td></tr>";
        })
        document.getElementById("linkers").innerHTML=preppedHtml
      })
    }
  }

  componentDidMount() {
    this.setState({ loading: true });

    this.fetchData();

    this.timer = setInterval(()=> this.updatePeriod(), 1000);

  }

  setInput(e, value) {
    this.setState({search: value});
  }

  pause() {
    this.setState({pause: true});
  }

  play() {
    this.setState({pause: false});
  }

  updatePeriod() {
    if (this.state.historical && !this.state.pause && !this.state.updating) {
      if (this.state.period + 1 < VALUES.length) {
        this.setState({ previousPeriod: this.state.period });

        const nextPeriod = this.state.period + 1 < VALUES.length ? this.state.period + 1 : 0;
        this.setState({ period: nextPeriod });
      }
      else {
        this.setState({ previousPeriod: 0 });
        this.setState({ period: 0 });
      }
      this.fetchData();
    }
  }

  toggleHistorical() {
    if (this.state.historical) { // changing to current.
      window.location.reload(false);
    }
    else {
      this.setState({usaMap: false});
      this.setState({pause: true});
      this.clear();
    }
  }

  clear() {
    this.setState({data: {}});
    this.setState({historical: true});
    this.setState({period: 0});
    this.setState({previousPeriod: 0});
    this.setState({loading: false});
    this.setState({zoomLevel: defaultZoom});
    this.setState({zoomLongitude: ""});
    this.setState({zoomLatitude: ""});
    this.setState({historical: true}, () => this.fetchData());
  }

  search() {
    this.setState({ loading: true })
    
    API.POST(`/bridges/conference-geolocation/`, {'id': this.state.search})    
    .then(response => response.json())
    .then(data => this.setState({ data }))
    .then(() => this.setState({ loading: false }))
    .then(() => this.setState({ previousPeriod: 0 }))
    .then(() => this.setState({ period: 0 }))
    .then(() => this.setState({ pause: false }))
    .then(() => this.setState({ historical: false }))
  }

  handleClick(event){
    let info = event.chart.getDevInfo();
    this.setState({zoomLongitude: info.longitude});
    this.setState({zoomLatitude: info.latitude});
  }

  handleZoom(event){
    let info = event.chart.getDevInfo();
    if (info.zoomLevel !== this.state.zoomLevel) {
      this.setState({zoomLevel: info.zoomLevel});
    }
  }

  changePeriod(index) {
    if (index !== this.state.period) {
      this.setState({data: {}});

      this.setState({period: index},
        () => this.setState({previousPeriod: 0}, () => this.fetchData())
      );
    }
  }

  initUSAMap(event) {
    let map = event.chart;

    if (map.dataProvider.images.length) {
      map.dataProvider.images = [];
    }

    // Set up a longitude exceptions for certain areas
    var longitude = {
      "US-CA": -130,
      "US-FL": 120,
      "US-TX": 1,
      "US-LA": 40
    };

    var latitude = {
      "US-AK": -83
    };

    // Positions of callouts
    var callouts = [
      70, 60, 46, 26, 3, -20, -40, -56
    ];

    var offset = 0;

    setTimeout( function() {
      // Iterate through areas and put a label over center of each map.dataProvider.images = [];
      for ( let x in map.dataProvider.areas ) {
        var area = map.dataProvider.areas[ x ];
        area.groupId = area.id;
        var image = new AmCharts.MapImage();
        image.title = area.title;
        image.linkToObject = area;
        image.groupId = area.id;

        // Callout or regular label
        if ( area.callout ) {
          image.latitude = callouts.shift();
          image.longitude = 165;
          image.label = area.value;
          image.type = "rectangle";
          image.color = area.color;
          image.shiftX = offset + 200;
          image.width = 10;
          image.height = 10;

          // Create additional image
          var image2 = new AmCharts.MapImage();
          image2.latitude = image.latitude;
          image2.longitude = image.longitude;
          image2.label = area.id.split( '-' ).pop();
          image2.labelColor = "#000";
          image2.labelShiftX = 30;
          image2.groupId = area.id;
          map.dataProvider.images.push( image2 );
        }
        else {
          image.latitude = latitude[ area.id ] || map.getAreaCenterLatitude( area );
          image.longitude = longitude[ area.id ] || map.getAreaCenterLongitude( area );
          image.label = area.id.split( '-' ).pop() + "\n" + area.value;
        }

        map.dataProvider.images.push( image );
      }
      map.validateData();
    }, 100 )
  }

  toggleOpenUSAMap() {
    this.setState({ usaMap: !this.state.usaMap });
    this.setState({zoomLevel: defaultZoom});
    this.setState({zoomLongitude: ""});
    this.setState({zoomLatitude: ""});
  }

  initAreas() {
    return [
    ]
  }

  render() {
    let destination = {};
    let dots = [];
    let lines = [];
    let data = undefined;
    let areas = this.initAreas().slice();
    const conferenceId = this.props.match.params.id;

    if (this.state.loading) {
      return (
        <div style={{ color: '#94a3b8', fontFamily: '"Inter", system-ui, sans-serif' }}>
          hello.  Could the links to the streams appear below?
         <div className="bg-primary">
             <div id="linkers">

             </div>
         </div>

        </div>
      );
    }

    data = this.state.data.data;

    if (data && 'destination' in data){
      destination = {
        latitude: data.destination.latitude,
        longitude: data.destination.longitude,
        number: '',
        id: data.destination.state,
        title: data.destination.state + ' ' + data.destination.number
      }
    }

    data && data.calls.forEach(c => {
      let dot = dots.find(obj => obj.latitude === c.latitude && obj.longitude === c.longitude);

      if (dot === undefined) {
        dots.push({
          "type": "circle",
          "width": minBulletSize,
          "height": minBulletSize,
          "title": c.state + ' ' + c.number,
          "latitude": c.latitude,
          "longitude": c.longitude,
          "color": "#bc5090",
          "rollOverColor": "#ff6361",
          "value": 1
        });
      }
      else {
        // The dot already exist, update circle size and title.
        dots[dots.indexOf(dot)]["value"] += 1;

        // Set title.
        if (dots[dots.indexOf(dot)]["value"] > 5) {
          dots[dots.indexOf(dot)]["title"] = c.state + ' callers: ' + dots[dots.indexOf(dot)]["value"];
        }
        else {
          dots[dots.indexOf(dot)]["title"] += ', ' + c.number;
        }

        // Set circle size.
        if (dots[dots.indexOf(dot)]["width"] + 1 > maxBulletSize) {
          let delta = 0.02;
          if (dots[dots.indexOf(dot)]["value"] > 1000) {
            delta = 0.009;
          }
          dots[dots.indexOf(dot)]["width"] = maxBulletSize + (dots[dots.indexOf(dot)]["value"] * delta);
          dots[dots.indexOf(dot)]["height"] = maxBulletSize + (dots[dots.indexOf(dot)]["value"] * delta);
        }
        else {
          dots[dots.indexOf(dot)]["width"] += 1;
          dots[dots.indexOf(dot)]["height"] += 1;
        }
      }

      if (this.state.usaMap) {
        // Update USA map.
        let area = areas.find(obj => obj.id === USAStatesMapToCode[c.state]);
        if (area) {
          areas[areas.indexOf(area)]["value"] += 1;
          areas[areas.indexOf(area)]["color"] = "#bc5090";
        }
      }
    });

    if (data && 'destination' in data){
      dots.map(d => lines.push({
        "latitudes": [ destination.latitude, d.latitude ],
        "longitudes": [ destination.longitude, d.longitude ]
      }))
    }

    const config = {
      "type": "map",
      "theme": "light",
      "dataProvider": {
        "map": 'worldLow',
        "zoomLevel": this.state.zoomLevel,
        "zoomLongitude": this.state.zoomLongitude,
        "zoomLatitude": this.state.zoomLatitude,
        "getAreasFromMap": true,
        "linkToObject": destination.id,
        "images": [ {
            "id": destination.id,
            "color": "#000000",
            "svgPath": targetSVG,
            "title": destination.title,
            "latitude": destination.latitude,
            "longitude": destination.longitude,
            "scale": 1.5,
            "lines": lines,
          },
          ...dots,
        ]
      },
      "imagesSettings": {
        "color": "#CC0000",
        "rollOverColor": "#CC0000",
        "selectedColor": "#000000"
      },
      "linesSettings": {
        "color": "#CC0000",
        "alpha": 0.4
      },
      "linesAboveImages": true,
      "areasSettings": {
        "autoZoom": true,
        "selectedColor": "#003f5c"
      },
      "listeners":[
        { "event": "zoomCompleted", "method": event => this.handleZoom(event) },
        { "event": "click", "method": event => this.handleClick(event) },
      ]
    };

    const configUsaMap = {
      "type": "map",
      "theme": "light",
      "dataProvider": {
        "map": 'usaLow',
        "areas": areas,
      },
      "areasSettings": {
        "autoZoom": true,
        "selectedColor": "#003f5c"
      },
      "listeners":[
        { "event": "rendered", "method": event => this.initUSAMap(event) },
      ]
    };

    return (
      <div>
        <TextField
          hintText="Search: enter the conference ID"
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              this.search();
          }}}
          onChange={this.setInput.bind(this)}
          value={this.state.search}
        />
        <div>
          {
            this.props.match.params.id
            ? <p style={{ marginTop: "10px", color: '#94a3b8', fontFamily: '"Inter", system-ui, sans-serif'}}>
              Conference detail of:
              <a style={{ cursor: 'pointer', color: '#3b82f6' }}
                onClick={() => this.props.history.push('/conference-detail/' + conferenceId)}>
                {conferenceId}
              </a>
            </p>
            : undefined
          }
        </div>
        <div>
          {!this.props.id && !this.props.match.params.id
            ?
              <RaisedButton
                label={this.state.historical ? 'Switch to current data': 'Switch to historical data'}
                primary={true}
                onClick={() => {this.toggleHistorical()}}
              />
            :
              undefined
           }
           <RaisedButton
             style={{marginLeft: '5px'}}
             label={!this.state.usaMap ? 'Open USA map' : 'Close USA map'}
             primary={true}
             onClick={() => {this.toggleOpenUSAMap()}}
           />
        </div>
        <div>
          {this.state.historical
            ?
              <div>
                <div style={{ width: '60%', height: '100px', margin: '0 auto' }}>
                  <HorizontalTimeline
                    index={this.state.period}
                    styles={{ background: '#1e293b', foreground: '#3b82f6', outline: '#334155' }}
                    indexClick={(index) => this.changePeriod(index)}
                    values={ VALUES } />
                </div>
                <div style={{ width: '60%', height: '100px', margin: '0 auto', textAlign: 'center' }}>
                  <RaisedButton
                    label="Play"
                    primary={true}
                    onClick={() => {this.play()}}
                    disabled={!this.state.pause ? true : false}
                  />
                  <RaisedButton
                    style={{marginLeft: '5px'}}
                    label="Pause"
                    primary={true}
                    onClick={() => {this.pause()}}
                    disabled={this.state.pause ? true : false}
                  />
                  <RaisedButton
                    style={{marginLeft: '5px'}}
                    label="Clear"
                    primary={true}
                    onClick={() => {this.clear()}}
                    disabled={this.state.pause && !this.state.updating? false : true}
                  />
                </div>
              </div>
            :
              undefined
          }
        </div>
        {this.state.usaMap
          ?
            <AmCharts.React style={{ width: "100%", height: "500px", marginTop: "40px" }} options={configUsaMap} />
          :
            <AmCharts.React style={{ width: "100%", height: "500px", marginTop: "40px" }} options={config} />
         }
      </div>
    );
  }
}

export default withRouter(PullConferenceStreams);



// WEBPACK FOOTER //
// ./src/PullConferenceStreams.js